<template>
  <vx-card :title="cardTitle">
    <!-- <div class="vx-row mb-base">
      <vs-select class="vx-col w-full md:w-1/ mt-1">
        <vs-select-item value="" text="Semua Posisi Berkas" class="w-full" />
        <vs-select-item v-for="(item,index) in itemsPosisi" :key="index"
          :value="item.value" :text="item.text" class="w-full"
        />
      </vs-select>
    </div> -->
    <vs-tabs>
      <vs-tab label="Harian">
        <Bar
          :chart-options="chartOptions"
          :chart-data="dailyChartData"
          :chart-id="'daily-chart'"
          :width="width"
          :height="height"
        />
      </vs-tab>
      <vs-tab label="Mingguan">
        <Bar
          :chart-options="chartOptions"
          :chart-data="weeklyChartData"
          :chart-id="'weekly-chart'"
          :width="width"
          :height="height"
        />
      </vs-tab>
      <vs-tab label="Bulanan">
        <Bar
          :chart-options="chartOptions"
          :chart-data="monthlyChartData"
          :chart-id="'monthly-chart'"
          :width="width"
          :height="height"
        />
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

export default {
  name: 'VisitorRecapChart',
  components: { Bar },
  props: {
    chartData:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        scales: {
          yAxes: [{
            id: 'y-axis-0',
            gridLines: {
              display: true,
              lineWidth: 0.3,
              color: "rgba(0,0,0,0.30)"
            },
            ticks: {
              beginAtZero:true,
              mirror:false
            }
          }]
        }
      },
      width: 400,
      height: 150,
      defaultColors: [
        'rgb(255, 99, 132)',
        'rgb(75, 192, 192)',
        'rgb(255, 205, 86)',
        'rgb(54, 162, 235)',
        'rgb(23, 23, 243)',
        'rgb(201, 203, 207)'
      ]
    }
  },
  computed: {
    dailyChartData(){
      return this.setDailyChartData(this.chartData.daily_data);
    },
    weeklyChartData(){
      return this.setWeeklyChartData(this.chartData.weekly_data);
    },
    monthlyChartData(){
      return this.setMonthlyChartData(this.chartData.monthly_data);
    },
    cardTitle (){
      return 'Statistik Kunjungan Tahun ' + new Date().getFullYear()
    }
  },
  methods: {
    setDailyChartData(data){
      if(typeof data === 'undefined') return {}
      let colors = data.dataset.map(function (){
        return 'rgb(54, 162, 235)';
      });

      return {
        labels: data.labels,
        datasets: [{
          label: `Kunjungan Harian `,
          data: data.dataset,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          barThickness: 20
        }]
      }
    },
    setWeeklyChartData(data){
      if(typeof data === 'undefined') return {}
      let colors = this.defaultColors;

      let datasets = data.datasets.map(function(item, key) {
        return {
          label: `Minggu Ke ${key+1}`,
          data: item,
          backgroundColor: colors[key],
          borderColor: colors[key],
          borderWidth: 1 
        }
      });

      return {
        labels: data.labels,
        datasets: datasets
      }
    },
    setMonthlyChartData(data){
      if(typeof data === 'undefined') return {}
      let colors = data.dataset.map(function (){
        return 'rgb(75, 192, 192)';
      });

      return {
        labels: data.labels,
        datasets: [{
          label: `Kunjungan Bulanan `,
          data: data.dataset,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          barThickness: 50
        }]
      }
    }
  }
}
</script>